/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthResponseDto } from '../../models/health-response-dto';

export interface HealthControllerPing$Params {
}

export function healthControllerPing(http: HttpClient, rootUrl: string, params?: HealthControllerPing$Params, context?: HttpContext): Observable<StrictHttpResponse<HealthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, healthControllerPing.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HealthResponseDto>;
    })
  );
}

healthControllerPing.PATH = '/health/ping';
